// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/iam/auditlog/auditlog.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canListLogs } from "./check";

export function useCanListLogs(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canListLogs(withinScope);
  return canDoAction;
}
